import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const WithdrawalWarningPopup = ({
  warnPopupOpen,
  handleClose,
  warningMsg,
  withdrawalItem,
}) => {
  const cancelApproval = () => {
    let data = {
      status: "Rejected",
    };

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/manual-withdrawal/update-status/${withdrawalItem?._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        handleClose(warningMsg);
      })
      .catch((error) => {
        console.log(error);
        handleClose(warningMsg);
      });
  };

  return (
    <Modal
      open={warnPopupOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <img
              src={withdrawalItem?.userId?.selected_Avatar}
              alt="Avatar"
              className="mr-2 h-14 w-14 rounded-full"
            />
            <h2 className="text-xl font-semibold tracking-wide">
              {withdrawalItem?.userId?.fullName}
            </h2>
          </div>
          <p className="mb-6 tracking-wide">
            {`Do you want to ${warningMsg} this withdrawal request?`}
          </p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              onClick={() => cancelApproval()}
              className="rounded bg-[#c51369] px-4 py-2 capitalize text-white hover:bg-[#a10f5b]"
            >
              {warningMsg}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default WithdrawalWarningPopup;
